// External
import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { logger } from "redux-logger";

// Default States
import mainState from "../components/Main/state";
import filtroBusquedaState from "../components/ActualizarArancel/FiltroBusqueda/state";
import grillaBusquedaState from "../components/ActualizarArancel/GrillaBusqueda/state";
import grillaSolicitudState from "../components/ActualizarArancel/GrillaSolicitud/state";
import nuevaPrestacionFormState from "../components/ActualizarArancel/NuevaPrestacionForm/state";
import editarPrestacionFormState from "../components/ActualizarArancel/EditarPrestacionForm/state";
import eliminarPrestacionFormState from "../components/ActualizarArancel/EliminarPrestacionForm/state";
import errorSnackState from "../components/ErrorSnack/state";
import solicitudEditarCreacionState from "../components/ActualizarArancel/SolicitudEditarCreacion/state";
import solicitudEditarEliminacionState from "../components/ActualizarArancel/SolicitudEditarEliminacion/state";
import solicitudEditarModificacionState from "../components/ActualizarArancel/SolicitudEditarModificacion/state";
import globalState from "../components/Global/state";
import filtroBusquedaSRState from "../components/SolicitudesRealizadas/FiltroBusqueda/state";
import grillaSolicitudesState from "../components/SolicitudesRealizadas/GrillaSolicitudes/state";
import detalleSolicitudSRState from "../components/SolicitudesRealizadas/DetalleSolicitud/state";
import filtroBusquedaRCState from "../components/RecargosConvenios/FiltroBusqueda/state";
import filtroBusquedaRCDetalleState from "../components/RecargosConvenios/FiltroBusquedaDetalle/state";
import filtroBusquedaRAState from "../components/ReajustarArancel/FiltroBusqueda/state";
import solicitudReajusteState from "../components/ReajustarArancel/SolicitudReajuste/state";
import replicarSolicitudState from "../components/ActualizarArancel/ReplicarSolicitud/state";
import filtroBusquedaSEState from "../components/SolicitudesEspeciales/FiltroBusqueda/state";
import datosPaginacion from "../components/PaginacionV2/state";

import filtroBusquedaPQState from "../components/Paquetes/FiltroBusquedaPQ/state";
import grillaBusquedaPQState from "../components/Paquetes/GrillaBusquedaPQ/state";
import grillaSolicitudPQState from "../components/Paquetes/GrillaSolicitud/state";
import filtroBusquedaAGState from "../components/ArancelGES/FiltroBusquedaArancelGES/state";
import grillaBusquedaAGState from "../components/ArancelGES/GrillaBusquedaArancelGES/state";
import filtroBusquedaPGState from "../components/PaqueteGES/FiltroBusquedaPaqueteGES/state";
import grillaBusquedaPGState from "../components/PaqueteGES/GrillaBusquedaPaqueteGES/state";
import editarPaqueteFormState from "../components/Paquetes/EditarPrestacionForm/state";


// Reducers
import mainReducer from "../components/Main/reducer";
import filtroBusquedaReducer from "../components/ActualizarArancel/FiltroBusqueda/reducer";
import grillaBusquedaReducer from "../components/ActualizarArancel/GrillaBusqueda/reducer";
import grillaSolicitudReducer from "../components/ActualizarArancel/GrillaSolicitud/reducer";
import nuevaPrestacionFormReducer from "../components/ActualizarArancel/NuevaPrestacionForm/reducer";
import editarPrestacionFormReducer from "../components/ActualizarArancel/EditarPrestacionForm/reducer";
import eliminarPrestacionFormReducer from "../components/ActualizarArancel/EliminarPrestacionForm/reducer";
import errorSnackReducer from "../components/ErrorSnack/reducer";
import solicitudEditarCreacionReducer from "../components/ActualizarArancel/SolicitudEditarCreacion/reducer";
import solicitudEditarEliminacionReducer from "../components/ActualizarArancel/SolicitudEditarEliminacion/reducer";
import solicitudEditarModificacionReducer from "../components/ActualizarArancel/SolicitudEditarModificacion/reducer";
import globalReducer from "../components/Global/reducer";
import filtroBusquedaSRReducer from "../components/SolicitudesRealizadas/FiltroBusqueda/reducer";
import grillaSolicitudesReducer from "../components/SolicitudesRealizadas/GrillaSolicitudes/reducer";
import detalleSolicitudSRReducer from "../components/SolicitudesRealizadas/DetalleSolicitud/reducer";
import filtroBusquedaRCReducer from "../components/RecargosConvenios/FiltroBusqueda/reducer";
import filtroBusquedaRCDetalleReducer from "../components/RecargosConvenios/FiltroBusquedaDetalle/reducer";
import filtroBusquedaRAReducer from "../components/ReajustarArancel/FiltroBusqueda/reducer";
import solicitudReajusteReducer from "../components/ReajustarArancel/SolicitudReajuste/reducer";
import replicarSolicitudReducer from "../components/ActualizarArancel/ReplicarSolicitud/reducer";
import filtroBusquedaSEReducer from "../components/SolicitudesEspeciales/FiltroBusqueda/reducer";
import paginacionReducer from "../components/PaginacionV2/reducer";

import filtroBusquedaPQReducer from "../components/Paquetes/FiltroBusquedaPQ/reducer";
import grillaBusquedaPQReducer from "../components/Paquetes/GrillaBusquedaPQ/reducer";
import grillaSolicitudPQReducer from "../components/Paquetes/GrillaSolicitud/reducer";
import filtroBusquedaAGReducer from "../components/ArancelGES/FiltroBusquedaArancelGES/reducer";
import grillaBusquedaAGReducer from "../components/ArancelGES/GrillaBusquedaArancelGES/reducer";
import filtroBusquedaPGReducer from "../components/PaqueteGES/FiltroBusquedaPaqueteGES/reducer";
import grillaBusquedaPGReducer from "../components/PaqueteGES/GrillaBusquedaPaqueteGES/reducer";
import editarPaqueteFormReducer from "../components/Paquetes/EditarPrestacionForm/reducer";



const rootState = {
  main: mainState,
  filtroBusqueda: filtroBusquedaState,
  grillaBusqueda: grillaBusquedaState,
  grillaSolicitud: grillaSolicitudState,
  nuevaPrestacionForm: nuevaPrestacionFormState,
  editarPrestacionForm: editarPrestacionFormState,
  eliminarPrestacionForm: eliminarPrestacionFormState,
  errorSnack: errorSnackState,
  solicitudEditarCreacion: solicitudEditarCreacionState,
  solicitudEditarEliminacion: solicitudEditarEliminacionState,
  solicitudEditarModificacion: solicitudEditarModificacionState,
  global: globalState,
  filtroBusquedaSR: filtroBusquedaSRState,
  grillaSolicitudes: grillaSolicitudesState,
  detalleSolicitudSR: detalleSolicitudSRState,
  filtroBusquedaRC: filtroBusquedaRCState,
  filtroBusquedaRCDetalle: filtroBusquedaRCDetalleState,
  filtroBusquedaRA: filtroBusquedaRAState,
  solicitudReajuste: solicitudReajusteState,
  replicarSolicitud: replicarSolicitudState,
  filtroBusquedaSE: filtroBusquedaSEState,
  paginacionState: datosPaginacion,

  filtroBusquedaPQ: filtroBusquedaPQState,
  grillaBusquedaPQ: grillaBusquedaPQState,
  filtroBusquedaAG: filtroBusquedaAGState,
  grillaBusquedaAG: grillaBusquedaAGState,
  filtroBusquedaPG: filtroBusquedaPGState,
  grillaBusquedaPG: grillaBusquedaPGState,
  editarPaqueteForm: editarPaqueteFormState,
  grillaSolicitudPQ: grillaSolicitudPQState,
};

const rootReducer = combineReducers({
  main: mainReducer,
  filtroBusqueda: filtroBusquedaReducer,
  grillaBusqueda: grillaBusquedaReducer,
  grillaSolicitud: grillaSolicitudReducer,
  nuevaPrestacionForm: nuevaPrestacionFormReducer,
  editarPrestacionForm: editarPrestacionFormReducer,
  eliminarPrestacionForm: eliminarPrestacionFormReducer,
  errorSnack: errorSnackReducer,
  solicitudEditarCreacion: solicitudEditarCreacionReducer,
  solicitudEditarEliminacion: solicitudEditarEliminacionReducer,
  solicitudEditarModificacion: solicitudEditarModificacionReducer,
  global: globalReducer,
  filtroBusquedaSR: filtroBusquedaSRReducer,
  grillaSolicitudes: grillaSolicitudesReducer,
  detalleSolicitudSR: detalleSolicitudSRReducer,
  filtroBusquedaRC: filtroBusquedaRCReducer,
  filtroBusquedaRCDetalle: filtroBusquedaRCDetalleReducer,
  filtroBusquedaRA: filtroBusquedaRAReducer,
  solicitudReajuste: solicitudReajusteReducer,
  replicarSolicitud: replicarSolicitudReducer,
  filtroBusquedaSE: filtroBusquedaSEReducer,
  paginacionState: paginacionReducer,

  filtroBusquedaPQ: filtroBusquedaPQReducer,
  grillaBusquedaPQ: grillaBusquedaPQReducer,
  filtroBusquedaAG: filtroBusquedaAGReducer,
  grillaBusquedaAG: grillaBusquedaAGReducer,
  filtroBusquedaPG: filtroBusquedaPGReducer,
  grillaBusquedaPG: grillaBusquedaPGReducer,
  editarPaqueteForm: editarPaqueteFormReducer,
  grillaSolicitudPQ: grillaSolicitudPQReducer,
});


const middlewares = [];
let store = {};
middlewares.push(thunkMiddleware);

if (process.env.NODE_ENV === "development") {
  // Adds logs to debug state changess
  middlewares.push(logger);

  const composeEnhancers =
    typeof window === "object" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      }) : compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));
  store = createStore(rootReducer, rootState, enhancer);
} else {
  store = createStore(
    rootReducer,
    rootState,
    applyMiddleware(...middlewares)
  );
}
export default store;



// WEBPACK FOOTER //
// ./src/config/store.js